// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2645790472/src/~/core-js/library/modules/_enum-bug-keys.js
// module id = Ic+c
// module chunks = 6